import React from 'react';

// WPSL TV Logo (Women's Premier Soccer League shield)
const LOGO_URL = "/wpsl-logo.svg";

export const Logo = ({ className = "h-10 w-auto" }) => (
  <img
    src={LOGO_URL}
    alt="WPSL TV"
    className={className}
  />
);

export default Logo;
